import { BooleanBase } from '../BooleanBase';

export class PremiumCTV extends BooleanBase {}
